import {Nullable} from '../../../app/TypeHelpers'
import {convertToNullableMoment} from '../../../components/reservations/helpers/helpers'
import moment from 'moment'

export const getFormattedYearMonthDay = (
    date: string
): string => {
    const dateMoment: Nullable<moment.Moment> = convertToNullableMoment(date, null)
    return (dateMoment) ? dateMoment.format('YYYY年M月D日') : ''
}

export const getFormattedYearMonth = (
    date: string
): string => {
    return date ? date.slice(0, 4) + '年' + String(Number(date.slice(4, 6))) + '月' : ''
}